import { Controller } from "stimulus"
export default class extends Controller {
  connect(){
    let time = parseInt(this.data.get('seconds'),10);
    const init_time = time;
    this.interval = setInterval(this.fixTime(this), 2000);
    document.addEventListener('turbolinks:load', function() {
      $('.carousel').carousel({interval: 10000}) 
    } )
   let t = this; 
   var remove  = function() {
   t.animateTiles('scaled-down'); }

   setTimeout(remove, 200); 

  }

  disconnect(){
    clearInterval(this.interval); 
    this.interval = null;
    document.removeEventListener('turbolinks:load', function() {
      $('.carousel').carousel({interval: 10000}) 
    } )


  }

  fixTime(t){
    return () => {
      let time = parseInt(t.data.get('seconds'),10);
      this.data.set('seconds', time - 1);
      if(time < 1){
        if(this.enabledTarget.checked){
          this.data.set('seconds', t.data.get('reset'));
          this.animateTiles('scaled-down', false); 
          Turbolinks.visit(location.toString());
        }
        else {
          this.data.set('seconds', t.data.get('reset'));
        }
      }
    }
  }


  animateTiles(className, removeClass=true) {
    document.querySelectorAll('.flex-flat-spin').forEach(function(v, i) {
      v.classList.toggle(className, (!removeClass)); 
    });

  
  }

  static get targets() {
    return ['enabled'];
  }
}
